// extracted by mini-css-extract-plugin
export var container = "survey-item-module--container--8af3c";
export var date = "survey-item-module--date--2f697";
export var dot = "survey-item-module--dot--f39c7";
export var icon = "survey-item-module--icon--bd407";